import { useEffect } from "react";
import { CustomDataArtifactRecord } from "types/AssistantTypes";
import colorsStore from "shared/store/colorsStore";
import { useTranslation } from "react-i18next";
import { FinecoButton } from "pages/assistant/components/FinecoButton";
import styles from "./finecoModelPortfoliosArtifact.module.css";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "shared/components/ui/tooltip";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "shared/components/ui/table";

type Props = {
  data: CustomDataArtifactRecord;
  onLoaded?: () => void;
  onSend: (text: string) => void;
};

const FinecoModelPortfoliosArtifact = ({ data, onLoaded, onSend }: Props) => {
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);
  const { t } = useTranslation();
  // const params = useParams();
  // const threadId = params.threadId;
  // const appendMessages = useThreadsStore((state) => state.appendMessages);

  useEffect(() => {
    onLoaded?.();
  }, [onLoaded]);

  if (!data?.portfolios || !data?.portfolio_instruments) {
    return null;
  }

  const handleImportClick = (portfolioName: string) => {
    const message = t("assistant.modelPortfolios.analyzeMessage", {
      portfolioName,
    });
    onSend(message);

    // const assistantMessage = createAssistantMessage(message, threadId);
    // appendMessages(threadId, [assistantMessage]);
  };

  return (
    <div className="space-y-4 p-4" key={Math.random()}>
      {data.portfolios.map((portfolio: any) => {
        return (
          <div
            key={portfolio.portfolio_name}
            className="rounded-lg p-4"
            style={{
              backgroundColor: colorsConfig.grayLight,
              color: colorsConfig.finecoBlack,
            }}
          >
            <h3
              className="mb-4 text-lg font-semibold"
              style={{ color: colorsConfig.portfolioTitle }}
            >
              {portfolio.portfolio_name}
            </h3>
            <h4 className={styles.portfolioCompositionTitle}>
              Composizione del portafoglio
            </h4>
            <div className={styles.tableContainer}>
              <Table className={styles.table}>
                <TableHeader>
                  <TableRow>
                    <TableHead>ISIN</TableHead>
                    <TableHead>Tipo Prodotto</TableHead>
                    <TableHead>Nome</TableHead>
                    <TableHead>Valuta</TableHead>
                    <TableHead className={styles.textRight}>
                      Peso sul PTF (%)
                    </TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {portfolio.weights
                    .sort((a: any, b: any) => b.weight - a.weight)
                    .map((weight: any) => {
                      const instrument =
                        data.portfolio_instruments[weight.isin];
                      return (
                        <TableRow key={weight.isin}>
                          <TableCell>{weight.isin}</TableCell>
                          <TableCell>{instrument?.tipo_strumento}</TableCell>
                          <TableCell className={styles.truncate}>
                            {instrument?.nome_strumento || weight.isin}
                          </TableCell>
                          <TableCell>{instrument?.valuta}</TableCell>
                          <TableCell
                            className={styles.textRight}
                            style={{
                              color: colorsConfig.artifactsDatoTextColor,
                            }}
                          >
                            {(weight.weight * 100).toFixed(2)}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </div>
            <div className={styles.buttonContainer}>
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <div>
                      <FinecoButton
                        click={() =>
                          handleImportClick(portfolio.portfolio_name)
                        }
                        copy={t(
                          "assistant.modelPortfolios.importButton",
                        ).toUpperCase()}
                      />
                    </div>
                  </TooltipTrigger>
                  <TooltipContent
                    side="top"
                    align="center"
                    backgroundColor={colorsConfig.tooltipBackground}
                    textColor={colorsConfig.tooltipText}
                  >
                    <p>{t("assistant.modelPortfolios.importTooltip")}</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FinecoModelPortfoliosArtifact;
